import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.NAidKb',
    defaultMessage: 'Notifications',
  },
  titleLabel: {
    id: 'studio.9a9+ww',
    defaultMessage: 'Title',
  },
  bodyLabel: {
    id: 'studio.T7Ry38',
    defaultMessage: 'Message',
  },
  enableInstructions: {
    id: 'studio.9JhU30',
    defaultMessage:
      'Push notifications are currently not enabled in this app. To enable sending out push notifications, please enable this in the <link>app definition</link> by specifying the “{navigation}” property.',
  },
  requestButton: {
    id: 'studio.nL/Owh',
    defaultMessage: 'Send notification',
  },
  submitSuccess: {
    id: 'studio.m90aUC',
    defaultMessage: 'Successfully sent notification!',
  },
  submitError: {
    id: 'studio.39Zi6V',
    defaultMessage: 'Something went wrong when submitting this notification.',
  },
});
